/** Event fired when a provider updates/loads their User Master profile */
export const PROFILE_UPDATED_EVENT = "Trivom-profile-updated";

const PROFILE_COMPLETION_FIELDS = [
  "user_role_id",
  "user_title",
  "first_name",
  "last_name",
  "gender",
  "age",
  "experience_years",
  "profile_picture",
  "status",
  "location_id",
  "phone_numbers",
  "linked_asset_ids",
  "specialization_ids",
  "video_bio_url",
  "brief_bio",
  "profile_pdf",
  "picture_gallery",
  "video_gallery",
  "email_addresses",
  "educational_qualifications",
  "incorporation_year",
  "registration_number",
  "registration_body",
  "registration_certificate",
  "pan_number",
  "pan_image",
  "aadhar_number",
  "aadhar_front",
  "aadhar_back",
  "gst_number",
  "gst_certificate",
  "bank_name",
  "bank_branch_address",
  "ifsc_code",
  "bank_account_number",
];

function hasValue(value) {
  if (value === null || value === undefined) return false;
  if (typeof value === "boolean") return true;
  if (typeof value === "number") return !Number.isNaN(value);
  if (Array.isArray(value)) {
    return value.some((item) => {
      if (item === null || item === undefined || item === "") return false;
      if (typeof item === "object") {
        return Object.values(item).some(
          (entry) => entry !== null && entry !== undefined && String(entry).trim() !== ""
        );
      }
      return String(item).trim() !== "";
    });
  }
  return String(value).trim() !== "";
}

export function calculateProfileCompletion(user) {
  if (!user) return 0;
  const filled = PROFILE_COMPLETION_FIELDS.filter((field) => hasValue(user[field])).length;
  return Math.round((filled / PROFILE_COMPLETION_FIELDS.length) * 100);
}

export function notifyProfileUpdated(payload = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(PROFILE_UPDATED_EVENT, {
      detail: payload,
    })
  );
}
